export default __webpack_public_path__ + "static/media/refresh.53cbeed3.svg";